<div *ngIf="data" fxLayout="column">
    <div class="pb-8" *ngIf="isHeaderNeedToShow">
        <p class="dark-text-80 font-weight-700 font-size-16 pt-4">{{ header | translate }} ({{ data.length }})</p>
    </div>

    <div
        fxLayout="column"
        class="infinite-scroll-bar infinte-scroll"
        fxLayoutGap="16px"
        infinite-scroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="100"
        [scrollWindow]="false"
        appFauxScrollbar
        [maxHeight]="200"
    >
        <ng-container *ngFor="let item of data; let i = index">
            <div
                fxLayout="row"
                fxLayoutAlign="start start"
                class="cursor-pointer mb-12"
                (click)="clickItem(item.ItemId)"
                id="am-1057"
                [matTooltip]="item | objectToDisplayString : toolTipDisplay : translateService.currentLang"
                matTooltipPosition="above"
                matTooltipClass="tooltip"
            >
                <div>
                    <mat-icon *ngIf="!isRadioButtonAvailable" class="font-size-12 badge-yellow mt-4" color="yellow">
                        lens
                    </mat-icon>

                    <p-checkbox
                        *ngIf="isRadioButtonAvailable"
                        class="mt-4"
                        [(ngModel)]="selectedConnectedCaseIds"
                        [value]="item.ItemId"
                        (onChange)="changeOption($event, item)"
                        (click)="$event.stopPropagation()"
                    ></p-checkbox>
                </div>

                <div
                    [ngClass]="
                        rootRoute === 'cases'
                            ? item?.CaseStatus?.Key === 'AUDIT_PHASE'
                                ? 'badge-red'
                                : 'badge-orange'
                            : 'badge-green'
                    "
                    fxLayout="column"
                    fxLayoutAlign="start start"
                >
                    <div class="font-size-14" fxLayout="row" fxLayoutAlign="start center">
                        <p>
                            {{
                                item
                                    | objectToDisplayString : titleDisplay : translateService.currentLang
                                    | truncateText : truncate
                            }}
                        </p>
                    </div>

                    <div class="font-size-14" fxLayout="row" fxLayoutAlign="start center">
                        <p>
                            {{
                                item
                                    | objectToDisplayString : subTitleDisplay : translateService.currentLang
                                    | truncateText : truncate
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-container>

        <app-no-data-found *ngIf="data.length === 0" />
    </div>
</div>
